// extracted by mini-css-extract-plugin
export var divider = "_ly-0";
export var labelWrapper = "_ly-2";
export var lineSvg = "_ly-1";